import dynamic from "next/dynamic";

// NOTE: Adding new icons
// FOR THE SVGS:
//   - add (or override) stroke and fill with `currentColor`
//   - correct html attributes like `strokeWidth` to React props like `strokeWidth`
//   - set the `viewBox`, othewise the resizing will break

const iconPaths: Record<any, any> = {
  account: dynamic(() => import("@/icons/icon-account")),
  "ai-makeup-advisor": dynamic(() => import("@/icons/icon-ai-makeup-advisor")),
  alert: dynamic(() => import("@/icons/icon-alert")),
  "alert-red": dynamic(() => import("@/icons/icon-alert-red")),
  alipay: dynamic(() => import("@/icons/icon-alipay")),
  amex: dynamic(() => import("@/icons/icon-amex")),
  apple: dynamic(() => import("@/icons/icon-apple")),
  appointment: dynamic(() => import("@/icons/icon-appointment")),
  "appointment-illustration": dynamic(() => import("@/icons/icon-appointment-illustration")),
  "arrow-left": dynamic(() => import("@/icons/icon-arrow-left")),
  "arrow-right": dynamic(() => import("@/icons/icon-arrow-right")),
  "best-clients": dynamic(() => import("@/icons/icon-best-clients")),
  bin: dynamic(() => import("@/icons/icon-bin")),
  birthday: dynamic(() => import("@/icons/icon-birthday")),
  "brokenheart-illustration": dynamic(() => import("@/icons/icon-brokenheart-illustration")),
  cart: dynamic(() => import("@/icons/icon-cart")),
  "cart-quantity": dynamic(() => import("@/icons/icon-cart-quantity")),
  "cash-on-delivery": dynamic(() => import("@/icons/icon-cash-on-delivery")),
  cashier: dynamic(() => import("@/icons/icon-cashier")),
  chat: dynamic(() => import("@/icons/icon-chat")),
  "checkbox-selected": dynamic(() => import("@/icons/icon-checkbox-selected")),
  "checkbox-unselected": dynamic(() => import("@/icons/icon-checkbox-unselected")),
  checkmark: dynamic(() => import("@/icons/icon-checkmark")),
  "checkmark-gradient": dynamic(() => import("@/icons/icon-checkmark-gradient")),
  "checkmark-gradient-v2": dynamic(() => import("@/icons/icon-checkmark-gradient-v2")),
  "chevron-down": dynamic(() => import("@/icons/icon-chevron-down")),
  "chevron-left": dynamic(() => import("@/icons/icon-chevron-left")),
  "chevron-right": dynamic(() => import("@/icons/icon-chevron-right")),
  "chevron-up": dynamic(() => import("@/icons/icon-chevron-up")),
  clear: dynamic(() => import("@/icons/icon-clear")),
  "click-and-collect": dynamic(() => import("@/icons/icon-click-and-collect")),
  "click-collect": dynamic(() => import("@/icons/icon-click-collect")),
  clock: dynamic(() => import("@/icons/icon-clock")),
  close: dynamic(() => import("@/icons/icon-close")),
  copy: dynamic(() => import("@/icons/icon-copy")),
  country: dynamic(() => import("@/icons/icon-country")),
  diamond: dynamic(() => import("@/icons/icon-diamond")),
  discount: dynamic(() => import("@/icons/icon-discount")),
  done: dynamic(() => import("@/icons/icon-done")),
  "double-chevron-down": dynamic(() => import("@/icons/icon-double-chevron-down")),
  "double-chevron-up": dynamic(() => import("@/icons/icon-double-chevron-up")),
  download: dynamic(() => import("@/icons/icon-download")),
  drag: dynamic(() => import("@/icons/icon-drag")),
  edit: dynamic(() => import("@/icons/icon-edit")),
  "engraving-color": dynamic(() => import("@/icons/icon-engraving-color")),
  facebook: dynamic(() => import("@/icons/icon-facebook")),
  "facebook-color": dynamic(() => import("@/icons/icon-facebook-color")),
  "fast-delivery": dynamic(() => import("@/icons/icon-fast-delivery")),
  filters: dynamic(() => import("@/icons/icon-filters")),
  "follow-on-social": dynamic(() => import("@/icons/icon-follow-on-social")),
  "fondazione-umberto-veronesi-color": dynamic(() => import("@/icons/icon-fondazione-umberto-veronesi-color")),
  "foundation-finder": dynamic(() => import("@/icons/icon-foundation-finder")),
  geolocation: dynamic(() => import("@/icons/icon-geolocation")),
  gift: dynamic(() => import("@/icons/icon-gift")),
  "gift-card": dynamic(() => import("@/icons/icon-gift-card")),
  google: dynamic(() => import("@/icons/icon-google")),
  "google-color": dynamic(() => import("@/icons/icon-google-color")),
  "green-vegan": dynamic(() => import("@/icons/icon-green-vegan")),
  heart: dynamic(() => import("@/icons/icon-heart")),
  "heart-path": dynamic(() => import("@/icons/icon-heart-path")),
  help: dynamic(() => import("@/icons/icon-help")),
  hide: dynamic(() => import("@/icons/icon-hide")),
  hourglass: dynamic(() => import("@/icons/icon-hourglass")),
  "inclined-star": dynamic(() => import("@/icons/icon-inclined-star")),
  info: dynamic(() => import("@/icons/icon-info")),
  instagram: dynamic(() => import("@/icons/icon-instagram")),
  "instagram-color": dynamic(() => import("@/icons/icon-instagram-color")),
  kiko: dynamic(() => import("@/icons/icon-kiko")),
  "kiko-id": dynamic(() => import("@/icons/icon-kiko-id")),
  "kiko-me": dynamic(() => import("@/icons/icon-kiko-me")),
  "kiko-small": dynamic(() => import("@/icons/icon-kiko-small")),
  kisses: dynamic(() => import("@/icons/icon-kisses")),
  "kisses-illustration": dynamic(() => import("@/icons/icon-kisses-illustration")),
  klarna: dynamic(() => import("@/icons/icon-klarna")),
  lamp: dynamic(() => import("@/icons/icon-lamp")),
  lens: dynamic(() => import("@/icons/icon-lens")),
  "loyalty-gift": dynamic(() => import("@/icons/icon-loyalty-gift")),
  "made-in-CN": dynamic(() => import("@/icons/icon-made-in-cn")),
  "made-in-CZ": dynamic(() => import("@/icons/icon-made-in-cz")),
  "made-in-DE": dynamic(() => import("@/icons/icon-made-in-de")),
  "made-in-ES": dynamic(() => import("@/icons/icon-made-in-es")),
  "made-in-FR": dynamic(() => import("@/icons/icon-made-in-fr")),
  "made-in-ID": dynamic(() => import("@/icons/icon-made-in-id")),
  "made-in-IT": dynamic(() => import("@/icons/icon-made-in-it")),
  "made-in-JP": dynamic(() => import("@/icons/icon-made-in-jp")),
  "made-in-KR": dynamic(() => import("@/icons/icon-made-in-kr")),
  "made-in-PL": dynamic(() => import("@/icons/icon-made-in-pl")),
  "made-in-US": dynamic(() => import("@/icons/icon-made-in-us")),
  maestro: dynamic(() => import("@/icons/icon-maestro")),
  "marvel-color": dynamic(() => import("@/icons/icon-marvel-color")),
  mastercard: dynamic(() => import("@/icons/icon-mastercard")),
  menu: dynamic(() => import("@/icons/icon-menu")),
  minus: dynamic(() => import("@/icons/icon-minus")),
  newsletter: dynamic(() => import("@/icons/icon-newsletter")),
  "non-shoppable-country": dynamic(() => import("@/icons/icon-non-shoppable-country")),
  "non-transfer": dynamic(() => import("@/icons/icon-non-transfer")),
  notify: dynamic(() => import("@/icons/icon-notify")),
  package: dynamic(() => import("~/components/common/icons/icon-package")),
  pao: dynamic(() => import("@/icons/icon-pao")),
  pause: dynamic(() => import("@/icons/icon-pause")),
  paypal: dynamic(() => import("@/icons/icon-paypal")),
  percentage: dynamic(() => import("@/icons/icon-percentage")),
  personalize: dynamic(() => import("@/icons/icon-personalize")),
  "pick-up": dynamic(() => import("@/icons/icon-pick-up")),
  play: dynamic(() => import("@/icons/icon-play")),
  "play-full": dynamic(() => import("@/icons/icon-play-full")),
  "play-pink": dynamic(() => import("@/icons/icon-play-pink")),
  "play-white": dynamic(() => import("@/icons/icon-play-white")),
  plus: dynamic(() => import("@/icons/icon-plus")),
  postepay: dynamic(() => import("@/icons/icon-postepay")),
  "privacy-options": dynamic(() => import("@/icons/icon-privacy-options")),
  promo: dynamic(() => import("@/icons/icon-promo")),
  "promo-big": dynamic(() => import("@/icons/icon-promo-big")),
  question: dynamic(() => import("@/icons/icon-question")),
  "radio-selected": dynamic(() => import("@/icons/icon-radio-selected")),
  "radio-unselectable": dynamic(() => import("@/icons/icon-radio-unselectable")),
  "radio-unselected": dynamic(() => import("@/icons/icon-radio-unselected")),
  recent: dynamic(() => import("@/icons/icon-recent")),
  "returns-days": dynamic(() => import("@/icons/icon-returns-days")),
  search: dynamic(() => import("@/icons/icon-search")),
  "search-arrow": dynamic(() => import("@/icons/icon-search-arrow")),
  "seasonal-palette": dynamic(() => import("@/icons/icon-seasonal-palette")),
  "secure-payment": dynamic(() => import("@/icons/icon-secure-payment")),
  share: dynamic(() => import("@/icons/icon-share")),
  shipping: dynamic(() => import("@/icons/icon-shipping")),
  "shipping-illustration": dynamic(() => import("@/icons/icon-shipping-illustration")),
  shop: dynamic(() => import("@/icons/icon-shop")),
  show: dynamic(() => import("@/icons/icon-show")),
  "skin-coach": dynamic(() => import("@/icons/icon-skin-coach")),
  "skin-diagnostic": dynamic(() => import("@/icons/icon-skin-diagnostic")),
  "skincare-advisor": dynamic(() => import("@/icons/icon-skincare-advisor")),
  sort: dynamic(() => import("@/icons/icon-sort")),
  "sorting-container": dynamic(() => import("@/icons/icon-sorting-container")),
  "sorting-glass": dynamic(() => import("@/icons/icon-sorting-glass")),
  "square-check": dynamic(() => import("@/icons/icon-square-check")),
  star25filled: dynamic(() => import("@/icons/icon-star-25-filled")),
  star75filled: dynamic(() => import("@/icons/icon-star-75-filled")),
  "star-empty": dynamic(() => import("@/icons/icon-star-empty")),
  "star-full": dynamic(() => import("@/icons/icon-star-full")),
  "star-half": dynamic(() => import("@/icons/icon-star-half")),
  "store-locator": dynamic(() => import("@/icons/icon-store-locator")),
  "store-locator-selected": dynamic(() => import("@/icons/icon-store-locator-selected")),
  suncare: dynamic(() => import("@/icons/icon-suncare")),
  sustainability: dynamic(() => import("@/icons/icon-sustainability")),
  tested: dynamic(() => import("@/icons/icon-tested")),
  tiktok: dynamic(() => import("@/icons/icon-tiktok")),
  "toggle-off": dynamic(() => import("@/icons/icon-toggle-off")),
  "toggle-on": dynamic(() => import("@/icons/icon-toggle-on")),
  trash: dynamic(() => import("@/icons/icon-trash")),
  twitter: dynamic(() => import("@/icons/icon-twitter")),
  uneditable: dynamic(() => import("@/icons/icon-uneditable")),
  "uv-protection": dynamic(() => import("@/icons/icon-uv-protection")),
  "video-consultation": dynamic(() => import("@/icons/icon-video-consultation")),
  "virtual-try-on": dynamic(() => import("@/icons/icon-virtual-try-on")),
  visa: dynamic(() => import("@/icons/icon-visa")),
  wallet: dynamic(() => import("@/icons/icon-wallet")),
  waterproof: dynamic(() => import("@/icons/icon-waterproof")),
  weight: dynamic(() => import("@/icons/icon-weight")),
  youtube: dynamic(() => import("@/icons/icon-youtube")),
  "youtube-color": dynamic(() => import("@/icons/icon-youtube-color")),
  "zoom-in": dynamic(() => import("@/icons/icon-zoom-in")),
  "zoom-out": dynamic(() => import("@/icons/icon-zoom-out")),
};

export default iconPaths;
